export const MARKETING_ROUTES = {
	HOME: "/",
	FEATURES: "/features",
	FAQ: "/faq",
	DOWNLOAD: "/download",
	ABOUT: "/about",
	CONTACT: "/contact",
	LEGAL_NOTICE: "/mentions-legales",
	PRIVACY: "/privacy",
	TERMS: "/terms-of-use",
} as const;
